export enum ISimilarityStatusFilterEnum {
  UNRESOLVED = 'Неразрешенное',
  RESOLVED = 'Принудительно разрешенное',
  JOINTLY = 'Совместное',
}

export enum ISimilarityStatusEnum {
  UNRESOLVED = 'UNRESOLVED',
  RESOLVED = 'RESOLVED',
  JOINTLY = 'JOINTLY',
}
